import Axios from 'axios';
import { inviteListeners } from './invite_listeners';
import { addToEmailList } from './addToEmailList';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';

const { simpleWelcomeEmail } = require('../../server/scripts/helpers/emailTemplate');
const { isProduction } = require('../../server/scripts/utils')();

export const sendEpisodeEmailNotification = (
  episodeId,
  recipients = ['subscribers', 'invitees']
) => {
  try {
    const emailRequests = recipients.map(recipient => {
      return Axios.post(`/api/episode/${episodeId}/notification/email/${recipient}`);
    });

    return Promise.all(emailRequests);
  } catch (err) {
    console.log(`Unable to send episode email notification`, err.message);
  }
};

export const sendSimpleWelcomeEmail = user => {
  const { firstName, lastName, email } = user;
  const { subject, html, from, bcc } = simpleWelcomeEmail({ name: firstName });
  const fromName = isObject(from) ? from.name : null;
  const fromEmail = isObject(from) ? from.email : from;

  inviteListeners(
    [{ firstName, lastName, email }], // invitees
    subject,   // subject
    html,      // content
    null,      // publisherId
    fromName,  // publisherName
    null,      // publisherImage
    fromEmail, // publisherEmail
    true,      // plainEmail
    isEmpty(bcc) ? false : bcc, // bcc
  );

  if (isProduction()) {
    addToEmailList(null, [email], 'soundwise publishers', 2876261); // 2876261 is the 'soundwise publishers' list id
  }
};
